import React from 'react'
import {
  AvanzamentoCommercialePerCommessaState,
  UpdatePercentualeOrdineFornitore,
} from '../localstate'
import { useQsDataTable } from 'react-use-datatable/react'
import OrdersSelectAutoComplete from '../../../components/OrdersSelectAutoComplete'
import DateRangeQsFilter from '../../../components/Planner/DateRangeQsFilter'
import moment from 'moment'
import { useMemo } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { useState } from 'react'
import { Field, Formik } from 'formik'
import { useRj } from 'react-rocketjump'
import { DateField, InputField } from '../../../components/Form/Fields'
import { ConfigPlannerContext } from '../../../context'
import { useContext } from 'react'
import { transformErrorForForm } from '../../../components/Form/Fields/utils'
import { sumBy } from 'lodash'
import { Link } from 'react-router-dom'

export default function AvanzamentoCommerciale() {
  const [
    { list: avanzamentiCommesse, loading: loadingCommesse },
    { ...filters },
    { run: runAvanzamentiCommesse, onFiltersChange },
  ] = useQsDataTable(AvanzamentoCommercialePerCommessaState, () => ({
    from_date:
      localStorage.getItem('planner_commerciale_from_date') ??
      moment().startOf('week').format('YYYY-MM-DD'),
    to_date:
      localStorage.getItem('planner_commerciale_to_date') ??
      moment().endOf('week').format('YYYY-MM-DD'),
    ordine: '',
  }))

  const filtersToUse = useMemo(() => {
    return {
      ...filters,
      page_size: 1000,
    }
  }, [filters])

  const [openModal, setOpenModal] = useState(null)

  const { run: updatePercentuale } = useRj(UpdatePercentualeOrdineFornitore)[1]

  const { valoriStato } = useContext(ConfigPlannerContext)
  const stati = valoriStato.ordine_fornitore || []

  const intestazioneThMateriali = useMemo(() => {
    if (!avanzamentiCommesse) {
      return []
    }
    const materiali = []
    avanzamentiCommesse.forEach((av) => {
      av.materiali.forEach((valore) => {
        if (!valore.materiale_nome) return
        if (!materiali.includes(valore.materiale_nome)) {
          materiali.push(valore.materiale_nome)
        }
      })
    })
    return materiali
  }, [avanzamentiCommesse])

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="filters mt-2">
            <div className="row">
              <div className="col-md-3">
                <OrdersSelectAutoComplete
                  value={filters.ordine}
                  hasValue
                  debounceTimeout={150}
                  loadOptionsOnMenuOpen
                  onChange={(ordine) => {
                    if (ordine) {
                      onFiltersChange({ ordine: ordine.id })
                    } else {
                      onFiltersChange({ ordine: '' })
                    }
                  }}
                  noOptionsMessage={() => 'Nessun ordine trovato'}
                  loadingMessage={() => 'Caricamento ordini...'}
                  placeholder={'Filtra per ordine'}
                  isClearable={true}
                  name={'ordine'}
                  additional={{
                    page: 1,
                  }}
                />
              </div>

              <div className="col-md-3 mt-1">
                <DateRangeQsFilter
                  filters={filters}
                  onFiltersChange={(newFilters) => {
                    onFiltersChange(newFilters)
                    localStorage.setItem(
                      'planner_commerciale_from_date',
                      newFilters.from_date
                    )
                    localStorage.setItem(
                      'planner_commerciale_to_date',
                      newFilters.to_date
                    )
                  }}
                  startField="from_date"
                  endField="to_date"
                  withPortal={true}
                  customArrowIcon={<div />}
                  small={false}
                  noBorder
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          height: 'calc(100vh - 150px)',
          overflowY: 'auto',
          overflowX: 'auto',
          width: 'calc(100vw - 30px)',
        }}
      >
        <table
          className="table table-striped table-orders mt-3"
          cellSpacing="0"
        >
          <thead
            className="position-sticky"
            style={{ top: 0, background: 'white', zIndex: 0 }}
          >
            <tr>
              <th colSpan={4}></th>
              {intestazioneThMateriali.map((materiale) => (
                <th key={materiale}>
                  <div className="badge badge-primary badge-xl">
                    {avanzamentiCommesse &&
                      sumBy(avanzamentiCommesse, (ac) => {
                        const materialeData = ac.materiali.find(
                          (m) => m.materiale_nome === materiale
                        )
                        // const materialiNonArrivati =
                        //   ac.materiali_non_arrivati.find(
                        //     (m) => m.materiale_nome === materiale
                        //   )
                        if (materialeData) {
                          return materialeData.totale_valore_economico || 0
                        } else {
                          return 0
                        }
                      })?.toFixed(2)}
                  </div>
                </th>
              ))}
              <th>
                <div className="badge badge-primary badge-xl">
                  {avanzamentiCommesse &&
                    sumBy(
                      avanzamentiCommesse,
                      'totale_valore_economico_ordine'
                    )?.toFixed(2)}
                </div>
              </th>
              <th>
                <div className="badge badge-primary badge-xl">
                  {avanzamentiCommesse &&
                    sumBy(avanzamentiCommesse, 'totale_avanzamento')?.toFixed(
                      2
                    )}
                </div>
              </th>
              <th>
                <div className="badge badge-primary badge-xl">
                  {avanzamentiCommesse &&
                    (
                      (sumBy(avanzamentiCommesse, 'totale_avanzamento') /
                        sumBy(
                          avanzamentiCommesse,
                          'totale_valore_economico_ordine'
                        )) *
                      100
                    )?.toFixed(2)}
                  %
                </div>
              </th>
            </tr>
            <tr>
              <th>Ordine</th>
              <th>Codice sistema</th>
              <th>Data approntamento</th>
              <th>Progetto</th>
              {intestazioneThMateriali.map((materiale) => (
                <th key={materiale}>Totale {materiale}</th>
              ))}
              <th>Totale commerciale</th>
              <th>Totale avanzamento</th>
              <th>Percentuale avanzamento</th>
            </tr>
          </thead>
          <tbody>
            {avanzamentiCommesse?.map((avanzamento) => (
              <tr key={avanzamento.ordine_id}>
                <td>
                  <Link
                    to={`/ordini/${avanzamento.ordine_id}/edit`}
                    className="text-decoration-none"
                  >
                    {avanzamento.numero_commessa} - {avanzamento.nome_cliente}
                  </Link>
                </td>
                <td>{avanzamento.codice_sistema}</td>

                <td>
                  {moment(avanzamento.data_approntamento).format('DD/MM/YYYY')}
                </td>
                <td>{avanzamento.progetto}</td>
                {intestazioneThMateriali.map((materiale) => {
                  const materialeData = avanzamento.materiali.find(
                    (m) => m.materiale_nome === materiale
                  )
                  const materialiNonArrivati =
                    avanzamento.materiali_non_arrivati.find(
                      (m) => m.materiale_nome === materiale
                    )
                  const ordiniFornitori = avanzamento.ordini_fornitori.filter(
                    (of) => of.tipologia === materiale
                  )
                  const ordiniFornitoriNonArrivati =
                    avanzamento.ordini_fornitori_non_arrivati.filter(
                      (of) => of.tipologia === materiale
                    )
                  return (
                    <td key={materiale}>
                      {materialeData ? (
                        materialeData.totale_valore_economico?.toFixed(2)
                      ) : materialiNonArrivati ? (
                        <span className="text-danger fw-bold">
                          {materialiNonArrivati.totale_valore_economico?.toFixed(
                            2
                          )}
                        </span>
                      ) : (
                        '0.00'
                      )}
                      <div className="mt-1">
                        <small>
                          {materialeData ? (
                            `(${materialeData.percentuale_avanzamento?.toFixed(
                              2
                            )}%)`
                          ) : materialiNonArrivati ? (
                            <span className="text-danger fw-bold">
                              (
                              {materialiNonArrivati.percentuale_avanzamento.toFixed(
                                2
                              )}
                              %)
                            </span>
                          ) : (
                            ''
                          )}
                        </small>
                      </div>
                      <hr />
                      <div>
                        {ordiniFornitori.length > 0
                          ? ordiniFornitori.map((of) => (
                              <div
                                key={of.pk}
                                className="d-flex align-items-center"
                              >
                                <small
                                  className={
                                    of.stato !== 'ARRIVATO'
                                      ? 'text-warning fw-bold'
                                      : ''
                                  }
                                >
                                  {of.fornitore__nome} <br />
                                  {of.stato}
                                  <br />
                                  {moment(of.data_arrivo).isValid()
                                    ? `(${moment(of.data_arrivo).format(
                                        'DD/MM/YYYY'
                                      )})`
                                    : ''}
                                </small>
                                <i
                                  className="fas fa-pencil-alt text-warning ml-2 pointer"
                                  style={{ fontSize: '0.7rem' }}
                                  title="Modifica ordine fornitore"
                                  onClick={() => {
                                    setOpenModal({
                                      ...of,
                                      id: of.pk,
                                      data_arrivo: of.data_arrivo,
                                      stato: of.stato,
                                      costo_materiale: of.costo_materiale,
                                      valore_percentuale: 100,
                                    })
                                  }}
                                />
                              </div>
                            ))
                          : null}
                        {ordiniFornitoriNonArrivati.length > 0
                          ? ordiniFornitoriNonArrivati.map((of) => (
                              <div
                                key={of.pk}
                                className="d-flex align-items-center"
                              >
                                <small className="text-danger fw-bold">
                                  {of.fornitore__nome} <br />
                                  {of.stato || 'NESSUNO'}
                                  <br />
                                  {moment(of.data_arrivo).isValid()
                                    ? `(${moment(of.data_arrivo).format(
                                        'DD/MM/YYYY'
                                      )})`
                                    : ''}
                                </small>
                                <i
                                  className="fas fa-pencil-alt text-warning ml-2 pointer"
                                  style={{ fontSize: '0.7rem' }}
                                  title="Modifica ordine fornitore"
                                  onClick={() => {
                                    setOpenModal({
                                      ...of,
                                      id: of.pk,
                                      data_arrivo: of.data_arrivo,
                                      stato: of.stato,
                                      costo_materiale: of.costo_materiale,
                                      valore_percentuale: 100,
                                    })
                                  }}
                                />
                              </div>
                            ))
                          : null}
                      </div>
                    </td>
                  )
                })}
                <td>
                  {avanzamento.totale_valore_economico_ordine?.toFixed(2)}
                </td>
                <td>{avanzamento.totale_avanzamento?.toFixed(2)}</td>
                <td>
                  {avanzamento.percentuale_avanzamento_ordine?.toFixed(2)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal
        isOpen={openModal}
        toggle={() => setOpenModal(null)}
        size="md"
        centered
      >
        <ModalHeader toggle={() => setOpenModal(null)}>
          Modifica ordine fornitore {openModal?.fornitore_data?.nome}
        </ModalHeader>
        <ModalBody>
          <Formik
            initialValues={{
              data_arrivo: openModal?.data_arrivo,
              stato: openModal?.stato,
              valore_percentuale: openModal?.valore_percentuale,
              costo_materiale: openModal?.costo_materiale,
            }}
            onSubmit={(values, actions) => {
              updatePercentuale
                .onSuccess(() => {
                  actions.setSubmitting(false)
                  setOpenModal(null)
                  runAvanzamentiCommesse({
                    ...filtersToUse,
                  })
                })
                .onFailure((error) => {
                  actions.setSubmitting(false)
                  actions.setErrors(transformErrorForForm(error))
                })
                .run(openModal.id, values)
              // updateStatoAndData
              //   .onSuccess(() => {
              //     actions.setSubmitting(false)
              //     setOpenModal(null)
              //   })
              //   .onFailure((error) => {
              //     actions.setSubmitting(false)
              //     actions.setErrors(transformErrorForForm(error))
              //   })
              //   .run(openModal.id, values)
            }}
          >
            {({ handleSubmit, isSubmitting }) => (
              <form onSubmit={handleSubmit}>
                <div className="form-group mt-3">
                  <Field
                    label="Data arrivo"
                    type="text"
                    name="data_arrivo"
                    component={DateField}
                    className="form-control"
                  />

                  <div className="form-group mt-3">
                    <Field
                      label="Stato"
                      type="select"
                      name="stato"
                      component={InputField}
                      className="form-control"
                    >
                      <option value=""></option>
                      {stati.map((stato) => (
                        <option key={stato.nome} value={stato.nome}>
                          {stato.nome}
                        </option>
                      ))}
                    </Field>
                  </div>
                  <div className="form-group mt-3">
                    <Field
                      label="Costo materiale"
                      name="costo_materiale"
                      component={InputField}
                      className="form-control"
                      type="number"
                      step="0.01"
                    />
                  </div>
                </div>

                <div className="form-group mt-3 d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    Salva
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
    </div>
  )
}
